import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getStartupConfig } from './actions';
import { restartWorkflow } from '../steps/actions';

import {
  selectMainIsLoading,
  selectMainLoadingMessage,
  selectMainLoadingVariant,
  selectConfiguration,
  selectIsConfigurationSet,
} from '../../../selectors';
import Main from './Component';

const mapStateToProps = createSelector(
  selectMainIsLoading,
  selectMainLoadingMessage,
  selectMainLoadingVariant,
  selectConfiguration,
  selectIsConfigurationSet,
  (isLoading, loadingMessage, loadingVariant, configuration, isConfigurationSet) => ({
    isLoading,
    loadingMessage,
    loadingVariant,
    configuration,
    isConfigurationSet,
  }),
);

const mapDispatchToProps = (dispatch) => ({
  getStartupConfig: () => dispatch(getStartupConfig()),
  restartWorkflow: () => dispatch(restartWorkflow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
